import { ModeEnum } from '@talos/kyoko';

export const LpSettlementMode = {
  None: 'none',
  Manual: 'manual',
  Auto: 'auto',
} as const;

export type LpSettlementMode = (typeof LpSettlementMode)[keyof typeof LpSettlementMode];

type SettlementFields = {
  SettlementMode?: ModeEnum;
  enableAutomaticBatching?: ModeEnum;
};

export function getLpSettlementModeFromSettlement(settlement: SettlementFields | undefined): LpSettlementMode {
  if (settlement?.SettlementMode !== ModeEnum.Enabled) {
    return LpSettlementMode.None;
  }
  if (settlement.enableAutomaticBatching === ModeEnum.Enabled) {
    return LpSettlementMode.Auto;
  }
  return LpSettlementMode.Manual;
}

export function applyLpSettlementModeToFields(mode: LpSettlementMode): {
  SettlementMode: ModeEnum;
  enableAutomaticBatching: ModeEnum;
} {
  switch (mode) {
    case LpSettlementMode.None:
      return {
        SettlementMode: ModeEnum.Disabled,
        enableAutomaticBatching: ModeEnum.Disabled,
      };
    case LpSettlementMode.Manual:
      return {
        SettlementMode: ModeEnum.Enabled,
        enableAutomaticBatching: ModeEnum.Disabled,
      };
    case LpSettlementMode.Auto:
      return {
        SettlementMode: ModeEnum.Enabled,
        enableAutomaticBatching: ModeEnum.Enabled,
      };
    default: {
      const _exhaustive: never = mode;
      return _exhaustive;
    }
  }
}

export function getLpSettlementModeDisplayName(mode: LpSettlementMode): string {
  switch (mode) {
    case LpSettlementMode.None:
      return 'Disabled';
    case LpSettlementMode.Manual:
      return 'Manual';
    case LpSettlementMode.Auto:
      return 'Auto';
    default: {
      const _exhaustive: never = mode;
      return _exhaustive;
    }
  }
}

export const LP_SETTLEMENT_MODE_TOGGLE_OPTIONS = [
  { value: LpSettlementMode.None, displayName: 'Disabled' },
  { value: LpSettlementMode.Manual, displayName: 'Manual' },
  { value: LpSettlementMode.Auto, displayName: 'Auto' },
] as const;
